<template>
    <div id="searchDiv">
    </div>
</template>

<script>
    import { loadModules } from 'esri-loader'

    export default {
        name: 'EsriSearch',
        props: ['clear'],
        data() {
            return {
                search: null
            }
        }, // data
        watch: {
            configLoaded: function (newVal) { if (newVal) this.loadSearch(); }
        },
        computed: {
            configLoaded: function () {
                return this.$store.state.configLoaded;
            },
            config: function () {
                return this.$store.state.config;
            },
            currLocation: function () {
                return this.$store.state.currItem;
            },
            locationSet: function () {
                return this.currLocation.location.lat && this.currLocation.location.lon;
            }
        },
        methods: {
            createNewLocation: function (address, geometry) {
                const newLocation = this.$store.state.emptyLocation();
                newLocation.address = address;
                newLocation.latitude = geometry.latitude;
                newLocation.longitude = geometry.longitude;
                this.$store.commit("setCurrItem", newLocation);
                this.$store.commit("currLocationTypeNew");
            },
            searchComplete: async function (evt) {
                const result = this.getFirstResult(evt.results);
                if (result !== null) {
                    //this.parcelSelected(result.feature.geometry, result.name);
                    this.createNewLocation(result.name, result.feature.geometry);
                    this.$emit("searchComplete", evt);
                } // if
            },
            getFirstResult: function (results) {
                // If there are multiple search providers the outer results array may have
                // one or more empty inner arrays before the acutal result(s)
                for (let i = 0; i < results.length; i++) {
                    if (results[i].results.length > 0)
                        return results[i].results[0];
                } // for

                return null;
            },
            searchClear: function () {
                this.$store.commit("currLocationTypeNone");
                this.$store.commit("clearCurrItem");
                this.$emit("searchClear");
            },
            loadSearch: async function () {
                const [esriConfig,
                    Search,
                    Locator] =
                    await loadModules([
                        'esri/config',
                        'esri/widgets/Search',
                        'esri/tasks/Locator'
                    ], { url: "" }).catch(err => { throw (err); });

                esriConfig.request.timeout = 10000;

                if (this.config.mapOptions.search) {
                    this.search = new Search({
                        sources: [{
                            name: "City of Brandon Parcel Locator",
                            placeholder: "e.g., 410 9th St",
                            singleLineFieldName: this.config.mapOptions.search.field,
                            locator: new Locator({
                                //url: "https://gisapp.brandon.ca/arcgis/rest/services/COBRA/COBRA_Public_Locator/GeocodeServer"
                                url: this.config.mapOptions.search.url
                            })
                        }],
                        includeDefaultSources: false,
                        autoSelect: false,
                        // popupOpenOnSelect: false,
                        popupEnabled: false,
                        locationEnabled: this.config.mapOptions.search.locationEnabled
                    });

                    if (this.config.mapOptions.search.container)
                        this.search.container = this.config.mapOptions.search.container;

                    this.search.on("search-complete", this.searchComplete);
                    this.search.on("search-clear", this.searchClear);
                } // if
            } // loadSearch
        }, // methods
        mounted() {
            if (this.configLoaded)
                this.loadSearch();
        } // mounted
    }
</script>

<style scoped>
    @import url("https://js.arcgis.com/4.19/esri/css/main.css");

    .esri-search__input {
        background-color: #f3f3f3;
        border-bottom: solid 1px #787878;
    }
</style>